import { IConfigsType } from '../../types'

const mwbOriginalCorporatePagesConfig: IConfigsType = {
  mwb: {
    '/:brand/expo_ai': {},
    '/:brand/rankings': {},
    '/:brand/flash': {},
    '/:brand/corporate_salesmanship': {},
    '/:brand/corporate_loss_prevention': {},
    '/:brand/corporate_inventory': {},
    '/:brand/corporate_delivery': {},
    '/:brand/corporate_product': {},
  },
}

export default mwbOriginalCorporatePagesConfig
